import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=f2ff8fd2&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=f2ff8fd2&prod&scoped=true&lang=css&external"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=f2ff8fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ff8fd2",
  null
  
)

export default component.exports